interface NotificationBannerProps {
    icon?: React.ReactNode
    content?: React.ReactNode

}

export const NotificationBanner = ({icon, content}: NotificationBannerProps) => {
    return (    
        <div className="bg-base-jobsite-yellow p-4 flex rounded-lg gap-3 font-Inter items-center">
            <div className="flex flex-row gap-2">
                {icon}
            </div>

            <p className="font-Inter text-sm ">
            {content}
            </p>
        </div>
    )
}